import { render, staticRenderFns } from "./NewDeveloperClientModal.vue?vue&type=template&id=0923a331&scoped=true&lang=pug"
import script from "./NewDeveloperClientModal.vue?vue&type=script&lang=js"
export * from "./NewDeveloperClientModal.vue?vue&type=script&lang=js"
import style0 from "./NewDeveloperClientModal.vue?vue&type=style&index=0&id=0923a331&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923a331",
  null
  
)

export default component.exports